// Centralized pdf.js worker configuration for React/Vite builds
// Solid approach: avoid bundler path probing and set workerSrc to a known URL.
// Allows override via Vite env: VITE_PDFJS_WORKER_URL

export async function setupPdfJsWorker(): Promise<void> {
  try {
    // @ts-ignore
    const { GlobalWorkerOptions } = await import('pdfjs-dist/build/pdf');
    // Prefer environment-provided worker URL if set
    // Guard for CRA: import.meta.env may not exist
    let envWorker: string | undefined;
    try {
      envWorker = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_PDFJS_WORKER_URL : undefined;
    } catch {
      envWorker = undefined;
    }
    const cdnWorker = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    const workerSrc: string = (typeof envWorker === 'string' && envWorker.trim()) ? envWorker : cdnWorker;
    if (GlobalWorkerOptions) {
      GlobalWorkerOptions.workerSrc = workerSrc;
    }
  } catch (e) {
    console.warn('pdf.js worker setup failed; continuing without explicit workerSrc:', e);
  }
}
